module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseInput', {
    attrs: {
      "error": _vm.error,
      "required": _vm.required,
      "append-text": _vm.appendText,
      "labelWidth": _vm.labelWidth
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('template', {
    slot: "input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentOption),
      expression: "currentOption"
    }],
    attrs: {
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateValue]
    }
  }, [_vm._t("noneValue", [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("---")])]), _vm._v(" "), _vm._l((_vm.options), function(option) {
    return _c('option', {
      key: option.value || option,
      domProps: {
        "value": option.value || option
      }
    }, [_vm._v("\n                " + _vm._s(option.label || option) + "\n            ")])
  })], 2)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5987dd94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Form/SelectBloc.vue
// module id = 3206
// module chunks = 0